module.exports = __webpack_public_path__ + "static/media/4-1.56920252.mp3";